<template>
    <div>
        <li class="root domain-row">
            <span><strong>{{domain.key}}</strong></span>
            <span>&nbsp;</span>
            <span><strong><a v-on:click="expandMe" href="#">{{domain.value}}</a></strong></span>
        </li>
        <template v-if="expanded" v-for="value in domain.values">
            <anchor-row v-bind:anchor="value"></anchor-row>
        </template>
    </div>
</template>

<script>
    import AnchorRow from '@/components/small/AnchorRow'

    export default {
        name: "DomainRow",
        components:{AnchorRow},
        props:{
            domain: Object
        },
        data: function (){
            return {
                expanded: false
            }
        },
        methods:{
            expandMe: function () {
                this.expanded = !this.expanded;
            }
        }
    }
</script>

<style scoped>
    #linkList ul li.domain-row {
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
    }

    #linkList ul li.domain-row span:last-of-type{
        text-align: right;
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active до версии 2.1.8 */ {
        transform: scaleY(0);

    }
</style>
